export default __webpack_public_path__ + "static/media/backpack_light.b479ea96.png";